import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BuyButton } from './BuyButton';
export function StickyCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-300">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-xl border-t border-white/10" data-id="element-301">
          <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between gap-4" data-id="element-302">
            <div className="flex items-center gap-4" data-id="element-303">
              <img src="https://cdn.magicpatterns.com/uploads/9CCgJrxPoFhcx9F91uxb8e/ChatGPT_Image_May_26,_2026_at_01_59_00_PM.png" alt="500 AI Prompts" className="w-10 h-13 object-contain hidden sm:block" data-id="element-304" />
              <div data-id="element-305">
                <h4 className="font-display font-black text-offwhite tracking-tight uppercase text-sm sm:text-base" data-id="element-306">
                  500 AI Prompts
                </h4>
                <div className="flex items-center gap-2 text-xs sm:text-sm" data-id="element-307">
                  <span className="text-muted line-through" data-id="element-308">$147</span>
                  <span className="text-gold font-bold" data-id="element-309">$27 USD</span>
                </div>
              </div>
            </div>

            <BuyButton label="Yes, I Want My 500 Prompts →" className="bg-gold text-black px-6 py-3 rounded-full text-sm font-bold hover:bg-gold-light transition-colors shadow-gold-glow uppercase tracking-wide whitespace-nowrap" data-id="element-310" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}